
import { useState,useCallback,useRef,useImperativeHandle,forwardRef, useEffect } from 'react'
import CustomStore from 'devextreme/data/custom_store';
import SelectBox,{SelectBoxTypes} from 'devextreme-react/select-box';
import { t } from 'i18next';
import { vendorService } from '../services/vendor_supply_parameter-service';
import { ArraySchema } from 'yup';
import ArrayStore from 'devextreme/data/array_store';



interface VendorSupplyParameterQueryProps{
    onchaged?: (location_code:string,location_name:string) => void,  
    clear?: (location_code:any) => void,  
}

const VendorSupplyParameterQuery = forwardRef((props:VendorSupplyParameterQueryProps, ref) => {

    const sb_locations= useRef<SelectBox>(null);
    const [locationStore,setLocationStore]  =useState<ArrayStore|undefined>();
    
    
    useEffect(() => {
        const load =async ()=>{
            var data=[{code:'0',name:t('syncflow:lb_all_location')}];
             (await vendorService.StoreLookups())
             .forEach((element: { code: string; name: string; }) => 
                {
                    data.push(element);
                });
                setLocationStore(new ArrayStore({
                    data: data,
                }));
        }
        load();        
    }, [])

   

    useImperativeHandle(ref, () => ({

        clear() {
            sb_locations.current?.instance.clear();  
        }
    
      }));    
    
    
    const onLocationChanged = useCallback((e: SelectBoxTypes.SelectionChangedEvent) => {       
        console.log(e.selectedItem.name);
        if(props.onchaged!=null) props.onchaged(e.selectedItem.code,e.selectedItem.name);
    }, []);
    
   

    return ( 
        <div className="row mb-12">
            {/* <label className="col-lg-1 col-form-label fw-bold fs-6">{t("syncflow:Vendors")}</label>
            <div className="col-lg-2">
                <div className="row">
                    <div className="fv-row">
                        <SelectBox   
                            ref={sb_vendors }              
                            dataSource={vendorStore}
                            valueExpr="code"
                            displayExpr="name"                    
                            onValueChanged={onVendorChanged}  
                            />
                    </div>
                </div>
            </div> */}
            <label className="col-lg-1 col-form-label fw-bold fs-6">{t("syncflow:location")}</label>
            <div className="col-lg-2">
                <div className="row">
                    <div className="fv-row">
                        <SelectBox   
                            ref={sb_locations }              
                            name="locations"
                            dataSource={locationStore}
                            valueExpr="code"
                            displayExpr="name"                    
                            onSelectionChanged={onLocationChanged}  
                            defaultValue={'0'}
                            searchEnabled={false}
                            />
                    </div>
                </div>
            </div>
        </div> 
    )
  });
  export default  VendorSupplyParameterQuery;